<script setup lang="ts">
import { useHubIndexing } from '@/data/Hubs/useHubIndexing'
import { useHubReindexing } from '@/data/Hubs/useHubReindexing'
import { useWorkspaceContext } from '@/modules/Workspaces/useWorkspaceContext'
import DarwinButton from '@/uiKit/DarwinButton.vue'
import DotIndicator from '@/uiKit/DotIndicator.vue'
import IconSprite from '@/uiKit/IconSprite.vue'
import { computed } from 'vue'

const props = defineProps<{ hubId: string }>()

const { workspaceId } = useWorkspaceContext()
const { isStale, isProcessing, isIndexing } = useHubIndexing({
  workspaceId: workspaceId,
  hubId: () => props.hubId,
})

const { mutate: reindex } = useHubReindexing({ workspaceId })

const isIndexable = computed(() => {
  return isStale.value && !isProcessing.value
})

function onClick() {
  reindex({ hubId: props.hubId })
}
</script>

<template>
  <DarwinButton
    size="sm"
    rounded
    :inert="!isIndexable"
    variant="neutral"
    :class="[isIndexable ? 'cursor-pointer' : 'bg-background-transparent']"
    @click.stop.prevent="onClick"
  >
    <template #leading-icon>
      <DotIndicator
        v-if="isProcessing"
        :reason="{ cause: 'computing' }"
      />
      <IconSprite
        v-else-if="isStale"
        size="sm"
        icon="switch"
        class="text-text-error"
      />
      <IconSprite
        v-else
        size="sm"
        icon="check-circle-fill"
        class="text-text-success"
      />
    </template>
    <template #default>
      <template v-if="isIndexing">Indexing…</template>
      <template v-else-if="isProcessing">Processing…</template>
      <template v-else-if="isStale">Re-index</template>
      <template v-else>Ready</template>
    </template>
  </DarwinButton>
</template>
